var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playbook-preview",style:(_vm.previewStyle)},[_c('playbooks-card-buttons',{attrs:{"template":_vm.template}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }